import type { CurrentSort, FilterSortOption } from '@jane/search/data-access';
import { FilterSortId, makeCurrentSort } from '@jane/search/data-access';

export const byAToZ: FilterSortOption = {
  id: FilterSortId.AZ,
  isDefault: false,
  label: 'A-Z',
  value: '',
};
const byAToZDefault: FilterSortOption = { ...byAToZ, isDefault: true };
const byPriceLowToHigh: FilterSortOption = {
  id: FilterSortId.PriceAsc,
  isDefault: false,
  label: 'Price Low to High',
  value: 'by-price-',
};
const byPriceHighToLow: FilterSortOption = {
  id: FilterSortId.PriceDesc,
  isDefault: false,
  label: 'Price High to Low',
  value: 'by-price-desc-',
};
const byThcLowToHigh: FilterSortOption = {
  id: FilterSortId.ThcAsc,
  isDefault: false,
  label: 'THC% Low to High',
  value: 'by-thc-potency-asc-',
};
const byThcHighToLow: FilterSortOption = {
  id: FilterSortId.ThcDesc,
  isDefault: false,
  label: 'THC% High to Low',
  value: 'by-thc-potency-desc-',
};
const byRating: FilterSortOption = {
  id: FilterSortId.Rating,
  isDefault: false,
  label: 'Rating',
  value: 'by-rating-',
};
const byRecommended: FilterSortOption = {
  id: FilterSortId.Recommended,
  isDefault: false,
  label: 'Recommended',
  value: 'by-recommendation-ordinal-asc-',
};
export const byRecommendedDefault: FilterSortOption = {
  ...byRecommended,
  isDefault: true,
};

export const sortOptionsWithRecommended: FilterSortOption[] = [
  byRecommendedDefault,
  byAToZ,
  byPriceLowToHigh,
  byPriceHighToLow,
  byThcLowToHigh,
  byThcHighToLow,
  byRating,
];

export const limitedSortOptions: FilterSortOption[] = [byAToZDefault, byRating];

/**
 * Ensures that Recommended is the default sort option.
 * Returns Recommended if:
 * - currentSort is undefined
 * - currentSort is a default sort but not Recommended
 * Returns null if:
 * - currentSort is already Recommended
 * - currentSort is not a default sort
 */
export const ensureRecommendedDefaultSort = (
  currentSort: CurrentSort | undefined
): CurrentSort | null => {
  if (currentSort && !currentSort.isDefault) {
    // non-default sorts should not be overridden
    return null;
  }

  const isRecommended = currentSort?.id === FilterSortId.Recommended;

  // If there's no current sort or it's not Recommended, return Recommended as default
  if (!currentSort || !isRecommended) {
    return makeCurrentSort(byRecommendedDefault);
  }

  // don't need to override if current sort is already Recommended
  return null;
};
